import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";

export function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato");
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=1400" alt="Warehouse" className="w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-black/60"/>
        <div className="absolute inset-0 flex items-end p-12 text-white">
          <div>
            <div className="font-display font-black text-6xl leading-none mb-2"><span>B</span><span className="text-[var(--bs-red)]">S</span></div>
            <div className="font-display font-black text-4xl tracking-tighter mb-2">Buti Stock</div>
            <div className="text-xs uppercase tracking-[0.3em] text-zinc-300">Vendita stock e fallimenti</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--bs-red)] mb-2">Area amministrativa</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Accesso admin</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] mb-2 block">Email</label>
              <Input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="rounded-none border-black"/>
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.2em] mb-2 block">Password</label>
              <Input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="rounded-none border-black"/>
            </div>
            <button data-testid="btn-login" disabled={loading} type="submit" className="bs-btn-primary w-full py-4 text-sm font-bold uppercase tracking-widest disabled:opacity-60">
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
          <div className="mt-6 text-sm text-[var(--bs-muted)]">Accesso riservato alla gestione del catalogo Buti Stock.</div>
         </div>
      </div>
    </div>
  );
}

export function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account creato");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore registrazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-16">
      <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--bs-red)] mb-2">Registrati</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Crea un account</h1>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-bold uppercase tracking-[0.2em] mb-2 block">Nome</label>
          <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="rounded-none border-black"/>
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-[0.2em] mb-2 block">Email</label>
          <Input data-testid="register-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="rounded-none border-black"/>
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-[0.2em] mb-2 block">Password</label>
          <Input data-testid="register-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" minLength={6} required className="rounded-none border-black"/>
        </div>
        <button data-testid="btn-register" disabled={loading} type="submit" className="bs-btn-primary w-full py-4 text-sm font-bold uppercase tracking-widest disabled:opacity-60">
          {loading ? "Attendere…" : "Registrati"}
        </button>
      </form>
      <div className="mt-6 text-sm text-[var(--bs-muted)]">
        Hai già un account? <Link to="/login" className="font-bold text-black hover:text-[var(--bs-red)]" data-testid="link-login">Accedi</Link>
      </div>
    </div>
  );
}
